import { C } from './loginAuthTheme';

/**
 * The empty frame behind AccessStatusScreen — same full-height background, no
 * card. A gate shows it while it is still learning what the card must say
 * (who the person is, the owner's Plan & billing state), so the card then
 * appears ONCE, complete, with its normal entrance — never a first version that
 * swaps or grows a moment later (founder, 2026-10-15).
 */
export default function AccessStatusBackdrop() {
  return (
    <div
      data-testid="access-status-pending"
      aria-busy="true"
      style={{ minHeight: '100dvh', width: '100%', background: C.page }}
    />
  );
}
